export const zd = {
  "zd.values.get": "zd.values.get",
  "zd.dealerStatuses.get": "zd.dealerStatuses.get",
  "zd.byId.get": "zd.byId.get",
  "zd.create": "zd.create",
  "zd.edit": "zd.edit",
  "zd.sort.set": "zd.sort.set",
  "zd.values.add": "zd.values.add",
  "zd.delete": "zd.delete",
  "zd.duplicate": "zd.duplicate",
  "zd.groups.get": "zd.groups.get",
  "zd.group.rename": "zd.group.rename",
  "zd.group.sort.set": "zd.group.sort.set",

  "zd.common.get": "zd.common.get",
  "zd.reports.get": "zd.reports.get",
  "zd.planReports.get": "zd.planReports.get",
  "zd.common.set": "zd.common.set",
  "zd.reports.set": "zd.reports.set",
  "zd.planReports.set": "zd.planReports.set",

  "zd.servicesEdit": "zd.servicesEdit",
  "zd.placesEdit": "zd.placesEdit",
  "zd.toolsMetrologicalEdit": "zd.toolsMetrologicalEdit",
  "zd.notesEdit": "zd.notesEdit",
  "zd.toolsInsuranceEdit": "zd.toolsInsuranceEdit",
  "zd.requiredToolsEdit": "zd.requiredToolsEdit",
  "zd.placePostEdit": "zd.placePostEdit",
  "zd.warehousesEdit": "zd.warehousesEdit",
  "zd.toolsEdit": "zd.toolsEdit",
  "zd.tradePremisesEdit": "zd.tradePremisesEdit",
  "zd.personalEdit": "zd.personalEdit",

  "zd.toolsMetrologicalCheck": "zd.toolsMetrologicalCheck",
  "zd.toolsInsuranceCheck": "zd.toolsInsuranceCheck",
  "zd.notesCheck": "zd.notesCheck",
  "zd.requiredToolsCheck": "zd.requiredToolsCheck",
  "zd.servicesCheck": "zd.servicesCheck",
  "zd.placesCheck": "zd.placesCheck",
  "zd.placePostCheck": "zd.placePostCheck",
  "zd.warehousesCheck": "zd.warehousesCheck",
  "zd.toolsCheck": "zd.toolsCheck",
  "zd.tradePremisesCheck": "zd.tradePremisesCheck",
  "zd.personalCheck": "zd.personalCheck",

  "zd.submitQuestionnaireForReview": "zd.submitQuestionnaireForReview",
  "zd.rejectWithoutSaleAreas": "zd.rejectWithoutSaleAreas",
  "zd.submitCommercialAreas": "zd.submitCommercialAreas",
  "zd.rejectSaleAreas": "zd.rejectSaleAreas",

  "dealergraph.federalArea.get": "dealergraph.federalArea.get",
  "zd.planReports.dealerfix": "zd.planReports.dealerfix",
} as const;
